// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prfilesummary-main-left img {
  width: 85%;
}

.prfilesummary-main-left {
  width: 15%;
}

.prfilesummary-main-right {
  width: 85%;
}

.prfilesummarydetail {
  background-color: #f3f6f9;
  padding: 30px 30px;
  border-radius: 12px;
}

.prfilesummarydetail p {
  font-size: 14px;
}

.prfilesummarydetail ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
  padding-bottom: 15px;
}

.prfilesummarydetail ul li {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
}

.prfilesummarydetail ul li span {
  padding-right: 30px;
  font-weight: 500;
}

.goal-box {
  display: flex;
}

.goal-box h5 {
  width: 10%;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
}

.goal-box ul {
  width: 90%;
}

.goal-box ul li {
  float: left;
  width: 25%;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
}

.goal-box ul li i {
  color: #55b56d;
}

/* Sidebar */
.sidebar {
  /* position: fixed; */
  top: 82px;
  bottom: 0;
  left: 0;
  padding: 0px 0 0;
  /* box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%), 0 2px 10px 0 rgb(0 0 0 / 5%); */
  width: 300px;
  z-index: 600;
  background-color: #0a25ca !important;
  padding-bottom: 22px;
}
.position-sticky {
  background-color: #f3f6f9;
}
@media (max-width: 991.98px) {
  .sidebar {
    width: 100%;
  }
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}
.rightside {
  width: 100%;
  padding: 20px 25px;
  background-color: #f1f1f1;
}
.profile header {
  justify-content: space-between;
}

.btn-prfl {
  background-color: #55b56d;
  border-color: #55b56d;
  border-radius: 0px;
  font-family: 'Poppins';
  color: #fff;
  padding: 8px 25px;
}
:hover.btn-prfl {
  background-color: unset;
  color: #55b56d;
}
.prfl-frm label {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}
.prfl-frm input {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: unset;
  border: 1px solid #55b56d;
  height: 50px;
  border-radius: 0px;
}
.prfl-frm input::placeholder {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 15px;
  color: #787272;
}
.prfl-frm-left img {
  width: 90%;
  margin: 0 auto;
  display: block;
}
.profiless-img input {
  width: 40px;
  height: 40px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  right: 80px;
  top: 74px;
  z-index: 11;
}
.profiless-img {
  position: relative;
}
.profiless-img i.fa.fa-camera {
  /* background-color: #55b56d; */
  width: 40px;
  height: 40px;
  position: absolute;
  right: 80px;
  top: 74px;
  text-align: center;
  padding: 9px 8px;
  border-radius: 50%;
  color: #55b56d;
  z-index: 10;
}
.camping-hd h4 {
  color: #212121;
  font-size: 18px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.camping-hd p {
  color: #b5b5c3;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.btn-all {
  border-radius: 5px;
  background: #55b56d;
  color: #fff;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  /* width: 140px; */
  height: 41px;
  padding: 12px 15px;
}
.card {
  border: 1px solid #fff;
  padding: 20px 20px;
  border-radius: 12px;
  margin-top: 20px;
}
.campaign-top {
  justify-content: space-between;
}
.table tbody,
td,
tfoot,
th,
thead,
tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-bottom: 1px solid #e5eaee;
  color: #464e5f;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  vertical-align: middle;
}
.table tbody tr td {
  padding: 12px;
}
.btn-veiw {
  color: #fff;
  font-size: 10px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 5px;
  background: #55b56d;
  padding: 8px 12px;
  display: block;
  width: -moz-fit-content;
  width: fit-content;
}

span.spn-2 {
  font-weight: 400 !important;
  padding-left: 28px;
}

.btn-prfledt {
  background-color: #55b56d;
  border-radius: 0px;
  width: 45px;
  height: 45px;
  color: #fff;
}

.profle-top img {
  width: 20%;
}
.profile-rght {
  width: 80%;
  padding-left: 50px;
}

.profile-rght h3 {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #000000;
  margin-top: 35px;
}
.profle-top {
  border-bottom: 1px solid #55b56d;
  padding-bottom: 30px;
}
.profil-lst label {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  width: 35%;
  border-bottom: 1px solid #55b56d;
  margin-bottom: 0px;
  padding: 5px 5px;
}
.profil-lst {
  padding-top: 0px;
  flex-wrap: wrap;
  width: 100%;
}
.profil-lst label:nth-child(odd) {
  width: 12%;
}
.profil-lst label:nth-child(even) {
  width: 88%;
}
.profil-lst label span {
  float: right;
}
.btn-prfledt {
  background-color: #55b56d;
  border-radius: 0px;
  width: 45px;
  height: 45px;
  color: #fff;
}
.btn-prfledt:focus {
  box-shadow: none;
}

.prfl-frm label {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 28px;
}
.prfl-frm input {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: unset;
  border: 1px solid #55b56d;
  height: 50px;
  border-radius: 0px;
}

.prfl-frm input::placeholder {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 15px;
  color: #787272;
}

/* .modal-dialog {
  max-width: 904px;
} */

/* .modal-content {
  border-radius: 0px;
}

.modal {
  position: fixed;
  top: 8px;
  left: 119px;
}

.modal-content .profle-top {
  margin-bottom: 20px;
} */

.btn-prfl {
  background-color: #55b56d;
  border-color: #55b56d;
  border-radius: 0px;
  font-family: 'Poppins';
  color: #fff;
  padding: 8px 25px;
}

:hover.btn-prfl {
  background-color: unset;
  color: #55b56d;
}

.prfl-frm {
  height: 100%;
}

.modal-body {
  padding-bottom: 100px;
}

.prfl-frm-left img {
  width: 40%;
  margin: 0 auto;
  display: block;
}

.profiless-img input {
  width: 40px;
  height: 40px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: -2px;
  z-index: 11;
}

.profiless-img {
  position: relative;
}

.profiless-img i.fa.fa-camera {
  /* background-color: #55b56d; */
  width: 40px;
  height: 40px;
  position: absolute;
  right: 80px;
  top: 74px;
  text-align: center;
  padding: 9px 8px;
  border-radius: 50%;
  color: #55b56d;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/UserDashboard/UserDashboard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,SAAS;EACT,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAE,6DAA6D;AACjF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb","sourcesContent":[".prfilesummary-main-left img {\r\n  width: 85%;\r\n}\r\n\r\n.prfilesummary-main-left {\r\n  width: 15%;\r\n}\r\n\r\n.prfilesummary-main-right {\r\n  width: 85%;\r\n}\r\n\r\n.prfilesummarydetail {\r\n  background-color: #f3f6f9;\r\n  padding: 30px 30px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.prfilesummarydetail p {\r\n  font-size: 14px;\r\n}\r\n\r\n.prfilesummarydetail ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.prfilesummarydetail ul li {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 28px;\r\n}\r\n\r\n.prfilesummarydetail ul li span {\r\n  padding-right: 30px;\r\n  font-weight: 500;\r\n}\r\n\r\n.goal-box {\r\n  display: flex;\r\n}\r\n\r\n.goal-box h5 {\r\n  width: 10%;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 28px;\r\n}\r\n\r\n.goal-box ul {\r\n  width: 90%;\r\n}\r\n\r\n.goal-box ul li {\r\n  float: left;\r\n  width: 25%;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 28px;\r\n}\r\n\r\n.goal-box ul li i {\r\n  color: #55b56d;\r\n}\r\n\r\n/* Sidebar */\r\n.sidebar {\r\n  /* position: fixed; */\r\n  top: 82px;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 0px 0 0;\r\n  /* box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%), 0 2px 10px 0 rgb(0 0 0 / 5%); */\r\n  width: 300px;\r\n  z-index: 600;\r\n  background-color: #0a25ca !important;\r\n  padding-bottom: 22px;\r\n}\r\n.position-sticky {\r\n  background-color: #f3f6f9;\r\n}\r\n@media (max-width: 991.98px) {\r\n  .sidebar {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.sidebar-sticky {\r\n  position: relative;\r\n  top: 0;\r\n  height: calc(100vh - 48px);\r\n  padding-top: 0.5rem;\r\n  overflow-x: hidden;\r\n  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */\r\n}\r\n.rightside {\r\n  width: 100%;\r\n  padding: 20px 25px;\r\n  background-color: #f1f1f1;\r\n}\r\n.profile header {\r\n  justify-content: space-between;\r\n}\r\n\r\n.btn-prfl {\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  border-radius: 0px;\r\n  font-family: 'Poppins';\r\n  color: #fff;\r\n  padding: 8px 25px;\r\n}\r\n:hover.btn-prfl {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n}\r\n.prfl-frm label {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 28px;\r\n}\r\n.prfl-frm input {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: unset;\r\n  border: 1px solid #55b56d;\r\n  height: 50px;\r\n  border-radius: 0px;\r\n}\r\n.prfl-frm input::placeholder {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 15px;\r\n  color: #787272;\r\n}\r\n.prfl-frm-left img {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n.profiless-img input {\r\n  width: 40px;\r\n  height: 40px;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  right: 80px;\r\n  top: 74px;\r\n  z-index: 11;\r\n}\r\n.profiless-img {\r\n  position: relative;\r\n}\r\n.profiless-img i.fa.fa-camera {\r\n  /* background-color: #55b56d; */\r\n  width: 40px;\r\n  height: 40px;\r\n  position: absolute;\r\n  right: 80px;\r\n  top: 74px;\r\n  text-align: center;\r\n  padding: 9px 8px;\r\n  border-radius: 50%;\r\n  color: #55b56d;\r\n  z-index: 10;\r\n}\r\n.camping-hd h4 {\r\n  color: #212121;\r\n  font-size: 18px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.camping-hd p {\r\n  color: #b5b5c3;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.btn-all {\r\n  border-radius: 5px;\r\n  background: #55b56d;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  /* width: 140px; */\r\n  height: 41px;\r\n  padding: 12px 15px;\r\n}\r\n.card {\r\n  border: 1px solid #fff;\r\n  padding: 20px 20px;\r\n  border-radius: 12px;\r\n  margin-top: 20px;\r\n}\r\n.campaign-top {\r\n  justify-content: space-between;\r\n}\r\n.table tbody,\r\ntd,\r\ntfoot,\r\nth,\r\nthead,\r\ntr {\r\n  border-color: inherit;\r\n  border-style: solid;\r\n  border-width: 0;\r\n  border-bottom: 1px solid #e5eaee;\r\n  color: #464e5f;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  vertical-align: middle;\r\n}\r\n.table tbody tr td {\r\n  padding: 12px;\r\n}\r\n.btn-veiw {\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  border-radius: 5px;\r\n  background: #55b56d;\r\n  padding: 8px 12px;\r\n  display: block;\r\n  width: fit-content;\r\n}\r\n\r\nspan.spn-2 {\r\n  font-weight: 400 !important;\r\n  padding-left: 28px;\r\n}\r\n\r\n.btn-prfledt {\r\n  background-color: #55b56d;\r\n  border-radius: 0px;\r\n  width: 45px;\r\n  height: 45px;\r\n  color: #fff;\r\n}\r\n\r\n.profle-top img {\r\n  width: 20%;\r\n}\r\n.profile-rght {\r\n  width: 80%;\r\n  padding-left: 50px;\r\n}\r\n\r\n.profile-rght h3 {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 30px;\r\n  line-height: 38px;\r\n  color: #000000;\r\n  margin-top: 35px;\r\n}\r\n.profle-top {\r\n  border-bottom: 1px solid #55b56d;\r\n  padding-bottom: 30px;\r\n}\r\n.profil-lst label {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 28px;\r\n  width: 35%;\r\n  border-bottom: 1px solid #55b56d;\r\n  margin-bottom: 0px;\r\n  padding: 5px 5px;\r\n}\r\n.profil-lst {\r\n  padding-top: 0px;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n}\r\n.profil-lst label:nth-child(odd) {\r\n  width: 12%;\r\n}\r\n.profil-lst label:nth-child(even) {\r\n  width: 88%;\r\n}\r\n.profil-lst label span {\r\n  float: right;\r\n}\r\n.btn-prfledt {\r\n  background-color: #55b56d;\r\n  border-radius: 0px;\r\n  width: 45px;\r\n  height: 45px;\r\n  color: #fff;\r\n}\r\n.btn-prfledt:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.prfl-frm label {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  line-height: 28px;\r\n}\r\n.prfl-frm input {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: unset;\r\n  border: 1px solid #55b56d;\r\n  height: 50px;\r\n  border-radius: 0px;\r\n}\r\n\r\n.prfl-frm input::placeholder {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 15px;\r\n  color: #787272;\r\n}\r\n\r\n/* .modal-dialog {\r\n  max-width: 904px;\r\n} */\r\n\r\n/* .modal-content {\r\n  border-radius: 0px;\r\n}\r\n\r\n.modal {\r\n  position: fixed;\r\n  top: 8px;\r\n  left: 119px;\r\n}\r\n\r\n.modal-content .profle-top {\r\n  margin-bottom: 20px;\r\n} */\r\n\r\n.btn-prfl {\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  border-radius: 0px;\r\n  font-family: 'Poppins';\r\n  color: #fff;\r\n  padding: 8px 25px;\r\n}\r\n\r\n:hover.btn-prfl {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n}\r\n\r\n.prfl-frm {\r\n  height: 100%;\r\n}\r\n\r\n.modal-body {\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.prfl-frm-left img {\r\n  width: 40%;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n\r\n.profiless-img input {\r\n  width: 40px;\r\n  height: 40px;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  right: 5px;\r\n  top: -2px;\r\n  z-index: 11;\r\n}\r\n\r\n.profiless-img {\r\n  position: relative;\r\n}\r\n\r\n.profiless-img i.fa.fa-camera {\r\n  /* background-color: #55b56d; */\r\n  width: 40px;\r\n  height: 40px;\r\n  position: absolute;\r\n  right: 80px;\r\n  top: 74px;\r\n  text-align: center;\r\n  padding: 9px 8px;\r\n  border-radius: 50%;\r\n  color: #55b56d;\r\n  z-index: 10;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
